import { availableFuels, yesOrNo } from './data';
import { CertificateType, ServiceType } from '../../typings/WindowEnvironmentProperties';

export const IS_PORTAL = () => !window?.ea48?.isMerchant;
export const IS_MERCHANT = () => window?.ea48?.isMerchant;
export const IS_PARTNER = () =>
  window?.ea48?.tenantConfiguration?.name && window?.ea48?.tenantConfiguration?.name !== 'ea48';

export const IS_SELF_SERVICE = () => window?.ea48?.serviceLevel === ServiceType.SELF_SERVICE;
export const IS_FULL_SERVICE = () => window?.ea48?.serviceLevel === ServiceType.FULL_SERVICE;
export const IS_VIDEO_SERVICE = () => window?.ea48?.serviceLevel === ServiceType.VIDEO_SERVICE;

export const IS_ACTIVE_SERVICE = () => IS_SELF_SERVICE() || IS_FULL_SERVICE() || IS_VIDEO_SERVICE();

export const IS_DEMAND = window?.ea48?.certificateType === CertificateType.DEMAND;
export const IS_CONSUMPTION = window?.ea48?.certificateType === CertificateType.CONSUMPTION;

export const IS_CONSUMPTION_PORTAL = () => IS_CONSUMPTION && IS_PORTAL();
export const IS_DEMAND_PORTAL = () => IS_DEMAND && IS_PORTAL();

export const TRUE_OPTION_ID = yesOrNo[0].id as string;
export const FALSE_OPTION_ID = yesOrNo[1].id as string;

export const HTTP_STATUS_2XX = (value: number) => value >= 200 && value < 300;
export const HTTP_CLIENT_ERROR = (value: number) => value >= 400 && value < 500;
export const HTTP_SERVER_ERROR = (value: number) => value >= 500 && value < 600;
export const HTTP_STATUS_OK = 200;
export const HTTP_STATUS_CREATED = 201;
export const HTTP_UNPROCESSABLE_ENTITY = 422;
export const BASE_API_URL = process.env.API_URL;
export const API_TIMEOUT = 50000;

export const PRODUCTS_ROUTE = '/';
export const CONFIGURATOR_ROUTE = PRODUCTS_ROUTE + 'configurator';
export const CONSUMPTION_CARD_ROUTE = PRODUCTS_ROUTE + '/verbrauchsausweis';
export const DEMAND_CARD_ROUTE = PRODUCTS_ROUTE + '/bedarfsausweis';
export const DEMAND_FULLSERVICE_CARD_ROUTE = PRODUCTS_ROUTE + '/bedarfsausweis-fullservice';
export const DEMAND_VIDEOSERVICE_CARD_ROUTE = PRODUCTS_ROUTE + '/bedarfsausweis-videoservice';
export const DEMAND_ORDER_ROUTE = '/demand-order';

export const BUNDLE_ROUTE = PRODUCTS_ROUTE + '/bundle';
export const BUNDLE_OVERVIEW_ROUTE = BUNDLE_ROUTE + '/overview';

export const CERTIFICATE_TYPE_ROUTING_MAP = {
  [CertificateType.CONSUMPTION]: '/consumption',
  [CertificateType.DEMAND]: '/demand',
};

export const CERTIFICATE_TYPE_GUEST_ROUTING_MAP = {
  [CertificateType.CONSUMPTION]: '/verbrauchsausweis',
  [CertificateType.DEMAND]: '/bedarfsausweis',
};

export const DEMAND_ORDER_SERVICE_TYPES = [
  ServiceType.FULL_SERVICE,
  ServiceType.PLUS_SERVICE,
  ServiceType.VIDEO_SERVICE,
];

export const SERVICE_LEVEL_ROUTING_MAP = {
  [ServiceType.PLUS_SERVICE]: 'plusservice',
  [ServiceType.FULL_SERVICE]: 'fullservice',
  [ServiceType.SELF_SERVICE]: 'selfservice',
  [ServiceType.VIDEO_SERVICE]: 'videoservice',
};

export const CONSUMPTION_CARD_BUILDING_INFORMATION_ROUTE = CONSUMPTION_CARD_ROUTE + '/building-information';
export const CONSUMPTION_CARD_CONSUMPTION_ROUTE = CONSUMPTION_CARD_ROUTE + '/consumption';
export const CONSUMPTION_CARD_RENEWABLE_ENERGY_ROUTE = CONSUMPTION_CARD_ROUTE + '/renewable-energy';
export const CONSUMPTION_CARD_ADDITIONAL_INFORMATION_ROUTE = CONSUMPTION_CARD_ROUTE + '/additional-information';
export const CONSUMPTION_CARD_CONSULTANT_ROUTE = CONSUMPTION_CARD_ROUTE + '/accredited-assessor';
export const CONSUMPTION_CARD_OVERVIEW_ROUTE = CONSUMPTION_CARD_ROUTE + '/overview';

export const CONSUMPTION_ROUTES_ARRAY = [
  CONSUMPTION_CARD_BUILDING_INFORMATION_ROUTE,
  CONSUMPTION_CARD_CONSUMPTION_ROUTE,
  CONSUMPTION_CARD_RENEWABLE_ENERGY_ROUTE,
  CONSUMPTION_CARD_ADDITIONAL_INFORMATION_ROUTE,
  CONSUMPTION_CARD_OVERVIEW_ROUTE,
];

export const DEMAND_CARD_BUILDING_INFORMATION_ROUTE = DEMAND_CARD_ROUTE + '/building-information';
export const DEMAND_CARD_GEOMETRY_ROUTE = DEMAND_CARD_ROUTE + '/geometry';
export const DEMAND_CARD_ENERGY_CONSUMPTION_ROUTE = DEMAND_CARD_ROUTE + '/energy-consumption';
export const DEMAND_CARD_ADDITIONAL_INFORMATION_ROUTE = '/additional-information';
export const DEMAND_CARD_OVERVIEW_ROUTE = '/overview';
export const DEMAND_CARD_CONSULTANT_ROUTE = '/accredited-assessor';
export const DEMAND_CARD_SURVEYOR_ROUTE = '/surveyor';
export const DEMAND_CARD_QS_ROUTE = '/qs';

export const DEMAND_ROUTES_ARRAY = [
  // START_PAGE_ROUTE,
  DEMAND_CARD_BUILDING_INFORMATION_ROUTE,
  DEMAND_CARD_GEOMETRY_ROUTE,
  DEMAND_CARD_ENERGY_CONSUMPTION_ROUTE,
  DEMAND_CARD_ADDITIONAL_INFORMATION_ROUTE,
];

export const LAST_ROUTE = () => DEMAND_ROUTES_ARRAY[DEMAND_ROUTES_ARRAY.length - 1];

// SUB ROUTES FOR FULL SERVICE
export const DEMAND_FULLSERVICE_CARD_BUILDING_INFORMATION_ROUTE =
  DEMAND_FULLSERVICE_CARD_ROUTE + '/building-information';
export const DEMAND_FULLSERVICE_CARD_OVERVIEW_ROUTE = DEMAND_FULLSERVICE_CARD_ROUTE + '/overview';

// SUB ROUTES FOR VIDEO SERVICE
export const DEMAND_VIDEOSERVICE_CARD_BUILDING_INFORMATION_ROUTE =
  DEMAND_VIDEOSERVICE_CARD_ROUTE + '/building-information';
export const DEMAND_VIDEOSERVICE_CARD_OVERVIEW_ROUTE = DEMAND_VIDEOSERVICE_CARD_ROUTE + '/overview';
export const DEMAND_VIDEOSERVICE_CARD_APPROVAL_PAGE_ROUTE = DEMAND_VIDEOSERVICE_CARD_ROUTE + '/approval';
export const DEMAND_VIDEOSERVICE_CARD_APPOINTMENT_PAGE_ROUTE = DEMAND_VIDEOSERVICE_CARD_ROUTE + '/appointment';

export const ADDITIONAL_INFORMATION_ROUTE = '/additional-information';
export const OVERVIEW_ROUTE = '/overview';
export const PRODUCT_SELECTION = '/performance-certificates/pick';
export const RENEWABLE_ENERGY_ROUTE = '/renewable-energy';
export const CONSUMPTION_ROUTE = '/consumption';
export const PRODUCT_SELECTION_ROUTE = '/produktauswahl';
export const REQUEST_ISSUING = '/request-issuing';
export const REJECT_CERTIFICATE_ROUTE = '/reject-certificate';
export const MEMBER_AREA_ORDERS_ROUTE = '/memberarea/orders';
export const MODERNIZATION_RECOMMENDATIONS_ROUTE = '/modernization-recommendations';
export const ISSUE_CERTIFICATE_ROUTE = '/issue-certificate';
export const START_PAGE_ROUTE = '/start-page';
export const CONSTRUCTION_INFORMATION_ROUTE = '/construction-information';
export const INSULATION_INFORMATION_ROUTE = '/insulation-information';
export const HEATING_SYSTEMS_ROUTE = '/heating-systems';
export const REQUEST_QUALITY_ASSURANCE_ROUTE = '/request-quality-assurance';
export const REQUEST_QUALITY_ASSURANCE_ACTION_ROUTE = '/request-qa-action';
export const REQUEST_CONFIRMATION_ROUTE = '/request-confirmation';
export const REQUEST_REJECTION_ROUTE = '/reject-certificate';
export const REQUEST_SERVICE_ACTION_ROUTE = '/request-service-action';
export const REQUEST_CONFIRM_DATA = '/confirm-data';
export const REQUEST_CONFIRM_DATA_WITH_CHANGES = '/confirm-data-cr';
export const REQUEST_BOOK_APPOINTMENT = '/book-appointment';
export const REQUEST_CONSTRUCTION_SIZE = '/construction-size';

// demand form
export const BUILDING_INFORMATION_ROUTE = '/building-information';
export const BUILDING_INFORMATION_ROUTES = '/affiliate-reference';
export const ENERGY_CONSUMPTION_ROUTE = '/energy-consumption';
export const GEOMETRY_ROUTE = '/geometry';

export const PAYMENT_URL_PARAMETER = 'status';
export const PARTIAL_STATE_STORAGE_KEY = 'last_app_state';
export const ORDER_ID_PARAMETER = 'orderId';

export const MIME_TYPES = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  png: 'image/png',
};

//Holz (lufttrocken)
export const FUEL_WOOD_ID = availableFuels[6].id;

//Strom
export const FUEL_ELECTRICITY_ID = availableFuels[9].id;

//Nah-/Fernwärme
export const FUEL_LOCAL_HEATING_ID = availableFuels[12].id;

//Braunkohle
export const FUEL_BROWN_COAL_ID = availableFuels[4].id;

//Steinkohle
export const FUEL_HARD_COAL_ID = availableFuels[5].id;

//Erdgas H / Erdgas E
export const FUEL_NATURAL_GAS_H_E = availableFuels[1].id;

//Erdgas L / Erdgas LL
export const FUEL_NATURAL_GAS_L_LL = availableFuels[2].id;

//Bio-Heizöl
export const FUEL_BIO_HEATING_OIL_ID = availableFuels[11].id;

//Heizöl EL
export const FUEL_HEATING_OIL_ID = availableFuels[0].id;

// Roles
export enum Roles {
  CONSULTANT = 'consultant',
  SERVICE = 'service',
  USER = 'user',
  QS = 'qs',
  SURVEYOR = 'surveyor',
  GUEST = 'guest',
  KPI = 'kpi',
}

export const IS_CONSULTANT = () => window?.ea48?.user?.role === Roles.CONSULTANT;
export const IS_QS = () => window?.ea48?.user?.role === Roles.QS;

export const IS_SERVICE_DESK = () =>
  window?.ea48?.user?.role === Roles.SERVICE || (window?.ea48?.hasBeenPaid && !IS_CONSULTANT() && IS_PORTAL());
export const IS_SERVICE = () => window?.ea48?.user?.role === Roles.SERVICE;

export const IS_SURVEYOR = () => window?.ea48?.user?.role === Roles.SURVEYOR;
export const IS_USER = () => window?.ea48?.user?.role === Roles.USER;
export const IS_GUEST = () => window?.ea48?.user?.role === Roles.GUEST;
export const IS_CONSULTANT_OR_SERVICE_DESK = () => IS_CONSULTANT() || IS_SERVICE();

export const IS_ROLE = (role: Roles): boolean => window?.ea48?.user?.role === role;
export const IS_ONE_OF_ROLE = (roles: Roles[]): boolean => roles.filter((role) => IS_ROLE(role)).length > 0;

export const CONSULTANT_ROUTE = '/accredited-assessor';
export const CONSULTANT_JSON_NAME = CONSULTANT_ROUTE.slice(1).replace('-', '_');

export const SURVEYOR_ROUTE = '/surveyor';
export const SURVEYOR_JSON_NAME = SURVEYOR_ROUTE.slice(1).replace('-', '_');

export const QS_ROUTE = '/qs';
export const QS_JSON_NAME = QS_ROUTE.slice(1);

export const LINKS = {
  SCOUT_REDIRECT:
    'https://www.immobilienscout24.de/immobilienbewertung/?cmp_id=10-051362&cmp_name=residential_realtorleadengine_ibw&cmp_position=rent_energy_certificate&cmp_creative=ibw-teaser_response_enc',
  SCOUT_CONSUMPTION: 'https://www.immobilienscout24.de/energieausweis/',
  PORTAL_LOGIN: 'https://portal.energieausweis48.de/login',
  PORTAL_PRODUCTS: 'https://portal.energieausweis48.de/memberarea/products',
};

export const PHONE_NUMBERS = {
  PORTAL: { HREF: 'tel:022182828290', TEXT: '0221-82 82 82 90' },
  SCOUT: { HREF: 'tel:022182829984', TEXT: '0221-82 82 99 84' },
};

export const KEYS_EVENTS_NAMES = {
  ENTER: 'Enter',
};

export const IS_CONSULTANTS_LIST = () => window?.ea48?.consultants && Object.keys(window.ea48.consultants).length > 0;
